export const getCookie = (cookieName: string) =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith(cookieName))
    ?.split("=")[1];
